import styles from "./Content.module.scss";
import Sidebar from "../../Components/Sidebar/Sidebar";
import React, { ReactNode, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { isMobileDevice } from "../../Utils/Utils";
import metadata from "../../metadata.json";
import { setIsMobile } from "../../Redux/Device/deviceSlice";

interface ContentProps {
  children: ReactNode;
  startTour?: boolean;
  setOpenTour?: React.Dispatch<React.SetStateAction<boolean>>;
}
const Content: React.FC<ContentProps> = ({ children }) => {
  const isOpen = useSelector((state: RootState) => state.sidebar.isOpen);
  const isMobile = useSelector((state: RootState) => state.device.isMobile);
  const dispatch = useDispatch();

  // @ts-ignore
  useEffect(() => {
    function handleResize() {
      dispatch(setIsMobile(isMobileDevice()));
    }

    window.addEventListener("resize", handleResize);
    return (_: any): void => {
      window.removeEventListener("resize", handleResize);
    };
  });


    return (
    <div className={`${styles.contentLayout}`}>
      <Sidebar />
      <div
        className={`${styles.container} ${isOpen ? styles["open"] : ""} ${
          isMobile ? styles["mobile"] : ""
        }`}
      >
        {children}
      </div>

      <div className={"footer"}>
        &copy; 2002-{new Date().getFullYear()} Wiline Networks, Inc. All Rights
        Reserved. UI Version:{" "}
        {`${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision} ${metadata.buildTag}`}
      </div>
    </div>
  );
};

export default Content;
